import React, { useState, useEffect } from 'react';
import { useAtomValue } from 'jotai';

import { spluginLoadStatusAtom } from '@/atoms/splugin';
import { deviceAtom } from '@/atoms/device';

interface SocialPluginProps {
  children: React.ReactElement<any, string | React.JSXElementConstructor<any>>;
  'data-title'?: string;
  'data-url'?: string;
}

const SocialPlugin: React.FC<SocialPluginProps> = ({ children, ...props }) => {
  const device = useAtomValue(deviceAtom);
  const { isComplete, error } = useAtomValue(spluginLoadStatusAtom);

  const [isInit, setIsInit] = useState(!isComplete || error);

  useEffect(() => {
    if (!isInit && isComplete && !error) {
      window.__splugin?.init();
      setIsInit(true);
    }
  }, [isInit, isComplete, error]);

  const element = React.Children.only(children);

  return React.cloneElement(element, {
    ...props,
    'data-style': device !== 'mo' ? 'type_a' : undefined,
    className: [element.props.className, 'naver-splugin'].filter((v) => v).join(' '),
  });
};

export default SocialPlugin;
